import { render, staticRenderFns } from "./VideoTour.vue?vue&type=template&id=01b8bed7&"
import script from "./VideoTour.vue?vue&type=script&lang=js&"
export * from "./VideoTour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports